export class Events {
    constructor() {
        this.inner = new Map();
    }
    add(src, type, listener, options) {
        if (!src || !listener) {
            return;
        }
        const typeMap = this.inner.get(type) || new Map();
        const elementSet = typeMap.get(src) || new Set();
        elementSet.add(listener);
        typeMap.set(src, elementSet);
        this.inner.set(type, typeMap);
        src.addEventListener(type, listener, options);
        return listener;
    }
    remove(src, type, listener, option) {
        if (!src || !listener) {
            return;
        }
        const typeMap = this.inner.get(type);
        if (typeMap) {
            const elementSet = typeMap.get(src);
            if (elementSet) {
                elementSet.delete(listener);
                if (!elementSet.size) {
                    typeMap.delete(src);
                    if (!typeMap.size) {
                        this.inner.delete(type);
                    }
                }
            }
        }
        src.removeEventListener(type, listener, option);
    }
    removeAll() {
        this.inner.forEach((typeMap, type) => {
            typeMap.forEach((eventListeners, src) => {
                eventListeners.forEach((listener) => {
                    src.removeEventListener(type, listener);
                });
            });
            typeMap.clear();
        });
        this.inner.clear();
    }
}
//# sourceMappingURL=events.js.map